"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { FlexCenter, Item, ItemContent, ItemDescription, ItemSide, ItemTitle, NumberDisplay, QuantityBadge, TableCell, TableRow, UnstyledButton } from "@opensea/ui-kit";
import { Close } from "@opensea/ui-kit/icons";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES } from "../CancelOrderTable/constants";
import { CancelOrderTableRowItem } from "../CancelOrderTableRowItem";
import { CancelOrderTableRow_orderFragment } from "./CancelOrderTableRow.fragment";
export const CancelOrderTableRow = t0 => {
  const $ = _c(34);
  const {
    item: itemKey,
    context,
    index
  } = t0;
  let t1;
  if ($[0] !== itemKey) {
    t1 = readFragment(CancelOrderTableRow_orderFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const order = t1;
  const {
    pricePerItem
  } = order;
  const {
    control
  } = useFormContext();
  let t2;
  if ($[2] !== control) {
    t2 = {
      keyName: "_id",
      control,
      name: "orders"
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    remove
  } = useFieldArray(t2);
  let t3;
  if ($[4] !== control) {
    t3 = {
      control,
      name: "orders"
    };
    $[4] = control;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const orders = useWatch(t3);
  let t4;
  if ($[6] !== order) {
    t4 = <CancelOrderTableRowItem order={order} />;
    $[6] = order;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== order.item?.isFungible || $[9] !== order.quantityRemaining || $[10] !== order.side) {
    t5 = order.item?.isFungible || order.side === "OFFER" ? <QuantityBadge>{order.quantityRemaining}</QuantityBadge> : null;
    $[8] = order.item?.isFungible;
    $[9] = order.quantityRemaining;
    $[10] = order.side;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <TableCell className={CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES.item}><FlexCenter className="gap-2">{t4}{t5}</FlexCenter></TableCell>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== pricePerItem.token.symbol || $[16] !== pricePerItem.token.unit) {
    t7 = <ItemTitle><NumberDisplay suffix={pricePerItem.token.symbol} value={pricePerItem.token.unit} /></ItemTitle>;
    $[15] = pricePerItem.token.symbol;
    $[16] = pricePerItem.token.unit;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== pricePerItem.usd) {
    t8 = <ItemDescription><NumberDisplay display="usd" value={pricePerItem.usd} /></ItemDescription>;
    $[18] = pricePerItem.usd;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <ItemContent className="items-end">{t7}{t8}</ItemContent>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== context?.view || $[24] !== index || $[25] !== orders.length || $[26] !== remove) {
    t10 = orders.length > 1 && context?.view === "cancel" && <ItemSide><UnstyledButton onClick={() => {
        remove(index);
      }}><Close fill="interactive-primary-styles" /></UnstyledButton></ItemSide>;
    $[23] = context?.view;
    $[24] = index;
    $[25] = orders.length;
    $[26] = remove;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t9) {
    t11 = <TableCell className={CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES.price}><Item variant="unstyled">{t9}{t10}</Item></TableCell>;
    $[28] = t10;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t6) {
    t12 = <TableRow>{t6}{t11}</TableRow>;
    $[31] = t11;
    $[32] = t6;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};